export default function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key)
    if (!stored) return defaultValue
    return JSON.parse(stored)
  }